import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { statusClass } from 'src/app/model/constants';
import { HomeApiService } from '../api/home.api.service';

@Component({
  selector: 'app-testimonial-home',
  templateUrl: './gallery-home.component.html',
  styleUrls: ['./gallery-home.component.scss']
})
export class TestimonialComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private homeApiService: HomeApiService
  ) {
  }

  testimonialList: any [] = [];

  ngOnInit(): void {
    this.getTestimonialList();
  }


  getTestimonialList(): void {
    this.homeApiService.getTestimonialList().subscribe(req => {
      if (req.code === statusClass.overall_success_response){
        this.testimonialList = req.data ? [...req.data] : null;
      }
    }, (error: any) => {
      console.log(error);
    });
  }

}
